import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5702892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "email-form-section" }
const _hoisted_2 = { class: "email-section-header" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" What we need for ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" requests ")
const _hoisted_5 = {
  key: 0,
  class: "warning-banner"
}
const _hoisted_6 = { class: "field-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormStructureInterpreter = _resolveComponent("FormStructureInterpreter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("strong", null, _toDisplayString(_ctx.getReadableInquiryType), 1),
      _hoisted_4
    ]),
    (_ctx.hasAttachments)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " The email includes an attachment(s), which may contain additional information not captured below. "))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generalFormNodes, (field) => {
        return (_openBlock(), _createBlock(_component_FormStructureInterpreter, {
          class: "js-general-form-interpreter",
          key: field.fieldId,
          field: field,
          emailSummary: _ctx.emailSummary,
          depth: 0
        }, null, 8, ["field", "emailSummary"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rootInquiryFormNodes, (field) => {
        return (_openBlock(), _createBlock(_component_FormStructureInterpreter, {
          class: "js-inquiry-form-interpreter",
          key: field.fieldId,
          field: field,
          emailSummary: _ctx.emailSummary,
          depth: 0
        }, null, 8, ["field", "emailSummary"]))
      }), 128))
    ])
  ]))
}